define('modules/editor/views/navigation_tab',['require','exports','module','base/itemview','common/views/confirmation_popup','../models/editorstate','ldsh!../templates/navigation_tab'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      ConfirmationPopup = require("common/views/confirmation_popup"),
      EditorState = require("../models/editorstate");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/navigation_tab"),
    tagName: "div",
    className: function () {
      return this.getClassForTab();
    },

    getClassForTab: function () {
      return 'ed-single-tab' + ' ed-tab-' + this.getTabRole();
    },

    events: {
      "click a": "onTabChange",
      "click .js-delete-step": "onDeleteStep"
    },

    initialize: function() {
      //this.listenTo(EditorState, "change:currentStep", this.toggleActive);
    },

    helpers: function() {
      var role = this.getTabRole();

      var templateParams = {
        translationKey: 'editor.toolbar.' + role + 'TabName',
        isRemovable: role === 'step' || role === 'popup',
        id: this.getTabId(),
        role: role
      };

      return templateParams;
    },

    getTabRole: function () {
      return this.model.get('role');
    },

    getTabId: function () {
      switch (this.getTabRole()) {
        case 'popup':
        case 'step':
          return this.model.get('step');

        case 'content':
          /* falls through */
        case 'confirmation':
          /* falls through */
        default:
          return '';
      }
    },

    onTabChange: function(e) {
      e.stopPropagation();
      e.preventDefault();
      EditorState.setCurrentStep(this.model.get("step"));
    },

    onDeleteStep: function(e) {
      e.stopPropagation();
      //this.model.destroy();
      var isPopup = $(e.delegateTarget).hasClass('ed-tab-popup'),
        popupParams = isPopup ?
          {
            title: $.i18n.t("landingPage.dialog.delete.popupTitle"),
            message: $.i18n.t("landingPage.dialog.delete.popupMessage")
          } : {
            title: $.i18n.t("landingPage.dialog.delete.title"),
            message: $.i18n.t("landingPage.dialog.delete.message")
          };

      ConfirmationPopup.show(popupParams)
      .then(_.bind(function(){
        this.model.destroy();
      }, this));
      //this.model.collection.removeStep(this.model);
    },

    toggleActive: function(activeStep) {
      var isActive = this.model.get("step") === activeStep;
      this.$el.toggleClass("active", isActive);
    },

    isSimpleTab: function () {
      return this.model.get("role") !== "step" && this.model.get("role") !== "popup";
    },

    getStepsNumber: function () {
      return this.model.collection.length;
    },

    fixNavigationLayoutByStepsNumber: function () {
      var maxTabWidth = this.getStepsNumber();

      this.$el.css({
        'width': 'calc(100% / ' + maxTabWidth + ')'
      });
    },

    onRender: function(){
      var activeStep = EditorState.getCurrentStep();
      this.toggleActive(activeStep);

      //  used for Tour
      this.$el.addClass("js-li-" + this.model.get("role"));

      this.$el.toggleClass("ed-simple-tab", this.isSimpleTab());
      this.fixNavigationLayoutByStepsNumber();

      this.$el.i18n();
    }
  });
});

